<template>
  <div>
    <div v-if="pagesWithIntegrationEnabled.length">
      <v-list>
        <v-list-item-group active-class="">
          <v-virtual-scroll
            class="list"
            :items="pagesWithIntegrationEnabled"
            :item-height="listItemHeight"
            :height="listHeight"
            ref="list"
          >
            <template v-slot:default="{ item }">
              <v-radio-group
                v-model="selectedItem"
                hide-details
                class="radio-group"
              >
                <v-list-item
                  :key="item.id"
                  :value="item.page_id"
                  :ripple="false"
                  class="list-item"
                  @click="selectedItem = item.page_id"
                >
                  <template v-slot:default>
                    <v-list-item-action class="list-item__action">
                      <v-radio :value="item.page_id" hide-details></v-radio>
                    </v-list-item-action>
                    <v-list-item-content>
                      <div class="list-item__content">
                        <div class="list-item__data">
                          <div class="list-item__description">
                            {{ item.name }}
                          </div>
                        </div>
                      </div>
                    </v-list-item-content>
                  </template>
                </v-list-item>
              </v-radio-group>
            </template>
          </v-virtual-scroll>
        </v-list-item-group>
      </v-list>

      <SectionLoader :status="loading" :opacity="0.75" />
    </div>
    <div v-else class="no-data">
      <p class="mb-0">
        {{ $t("message.common.noData") }}
      </p>
      <SectionLoader :status="loading" :opacity="1" />
    </div>

    <div class="action-bar">
      <ui-button
        color="primary"
        :disabled="!selectedItem"
        @click="handleNextStep"
      >
        {{ $t("message.common.further") }}
      </ui-button>
    </div>
  </div>
</template>

<script>
import SectionLoader from "@/components/Loader/SectionLoader";
import serviceHandler from "@/helpers/handlers/service";
import facebookService from "@/services/facebook";

export default {
  name: "FbPostsDialogPageSelectionView",
  components: {
    SectionLoader
  },
  data() {
    return {
      selectedItem: null,
      pages: [],
      listItemHeight: 62
    };
  },
  computed: {
    listHeight() {
      const maxListItems = window.innerWidth > 1400 ? 4 : 2;
      return this.listItemHeight * maxListItems;
    },
    pagesWithIntegrationEnabled() {
      return this.pages.filter(page => page.is_integration_enabled);
    }
  },
  async created() {
    await this.fetchPages();
  },
  methods: {
    handleNextStep() {
      this.$emit("next-step", this.selectedItem);
    },

    async fetchPages() {
      this.loading = true;
      const data = await serviceHandler(facebookService.getPages());

      this.pages = data;
      this.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.v-tooltip__content {
  background: rgba(darken($primary, 30%), 0.95) !important;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: $spacing;
}

::v-deep {
  .v-list {
    padding: 0;
  }

  .v-input--radio-group__input {
    height: 62px;
  }

  .radio-group {
    padding-top: 0;
    margin-top: 0;
  }
}

.list {
  border-top: 1px solid $light-3;
  position: relative;
}

.list-item {
  border-bottom: 1px solid $light-3;
  height: 62px !important;

  &__data {
    display: flex;
    align-items: center;
  }

  &__content {
    display: flex;
    flex-direction: row;
    gap: $spacing * 2;
    align-items: center;
    @include font-size(14px);
  }

  &__description {
    color: $dark;
    line-height: 1.4em;
  }
}

.action-bar {
  display: flex;
  justify-content: flex-end;
  padding: 24px 0;
}

.no-data {
  @include noData(100px);
}
</style>
